import { render, staticRenderFns } from "./ContactPerson.vue?vue&type=template&id=6fc77487&scoped=true"
import script from "./ContactPerson.vue?vue&type=script&lang=js"
export * from "./ContactPerson.vue?vue&type=script&lang=js"
import style0 from "./ContactPerson.vue?vue&type=style&index=0&id=6fc77487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc77487",
  null
  
)

export default component.exports